<div class="forgot-password-container">
  <h2 mat-dialog-title>Forgot Password</h2>
  <mat-dialog-content>
    <div class="input-area" *ngIf="!formSubmitted || !success">
      <p>Enter your email address</p>
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Email</mat-label>
        <input
          matInput
          [formControl]="emailControl"
          type="email"
          placeholder="example@example.com"
          required
          (focus)="onFocus()"
          (keydown.enter)="onSubmit()"
        />
      </mat-form-field>
      <mat-error *ngIf="emailControl.hasError('required') && (emailControl.touched || formSubmitted)">
        Email is required
      </mat-error>
      <mat-error *ngIf="emailControl.hasError('email') && (emailControl.touched || formSubmitted)">
        Please enter a valid email
      </mat-error>
    </div>
    <p *ngIf="message" class="message">{{ message }}</p>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button mat-dialog-close *ngIf="!formSubmitted || !success">Back</button>
    <button
      mat-raised-button
      color="primary"
      (click)="onSubmit()"
      [disabled]="!emailControl.valid"
      *ngIf="!formSubmitted || !success"
    >
      Reset Password
    </button>
    <button mat-raised-button color="primary" mat-dialog-close *ngIf="success">Close</button>
  </mat-dialog-actions>
</div>
